import React from 'react'
import { animated, useSpring } from 'react-spring'
import AddIcon from '../../../atoms/Svgs/Add'
import InvoiceIcon from '../../../atoms/Svgs/Invoice'
import ContactsWhiteIcon from '../../../atoms/Svgs/Contacts'
import ContactSettingsFill from '../../../atoms/Icons/User/ContactSettingsFill'
import FilterIcon from '../../../atoms/Icons/Controls/Filter'
import CloseIcon from '../../../atoms/Svgs/Close'
import { animationConfig } from '../../../../constants'
import Shortcut from './Shortcut/Shortcut'
import styles from './ShortcutsDrawer.module.scss'
import { ROUTES } from '../../../../../constants/routes'
import { useSelector } from 'react-redux'
import { userApiSelectors } from 'modules/api/user'
import { TUserRole } from 'utils/auth'

type TProps = {
  open: boolean
  onClose: () => void
  userRole: TUserRole | null
  redirect: (path: string) => void
  agencyCreated: boolean
}

const ShortcutsDrawer = ({ open, onClose, userRole, redirect, agencyCreated }: TProps) => {
  const isValidSupportStaff = useSelector(userApiSelectors.isValidSupportStaff)
  const shortcuts = [
    {
      icon: <AddIcon />,
      title: 'Add lease',
      subtitle: 'Capture your lease details in reOS',
      onClick: () => redirect('/leases/new/edit'),
      visible: true,
    },
    {
      icon: <InvoiceIcon />,
      title: 'Create ad hoc invoice',
      subtitle: 'Send or save a once-off invoice',
      onClick: () => redirect(ROUTES.adhocInvoice),
      visible: agencyCreated,
    },
    {
      icon: <ContactsWhiteIcon />,
      title: 'Create contact',
      subtitle: 'Add a tenant, owner or beneficiary',
      onClick: () => redirect(ROUTES.newContact),
      visible: true,
    },
    {
      icon: <ContactSettingsFill fill="#fff" />,
      title: 'Invite user',
      subtitle: 'Add someone to help manage your book',
      onClick: () => redirect(ROUTES.inviteUser),
      visible: userRole === 'Owner' && agencyCreated,
    },
    {
      icon: <FilterIcon stroke="#fff" />,
      title: 'Create segment',
      subtitle: 'Helps you keep your leases organised',
      onClick: () => redirect(ROUTES.segmentView.replace(':id', 'new')),
      visible: userRole === 'Owner' && agencyCreated,
    },
  ].map(shortcut => ({
    ...shortcut,
    onClick: () => {
      onClose()
      shortcut.onClick()
    },
  }))

  const style = useSpring({
    reverse: !open,
    config: animationConfig,
    to: { transform: 'translateX(0)' },
    from: { transform: 'translateX(110%)' },
  })

  return (
    <animated.div id="rbn-shortcuts" className={styles.root} style={style}>
      <button className={styles.close} onClick={onClose}>
        <CloseIcon />
      </button>
      <h1>Shortcuts</h1>
      <ul className={styles.shortcuts}>
        {shortcuts
          .filter(s => s.visible)
          .map((s, i) => (
            <li key={i}>
              <Shortcut icon={s.icon} title={s.title} subtitle={s.subtitle} onClick={s.onClick} />
            </li>
          ))}
      </ul>
    </animated.div>
  )
}

export default ShortcutsDrawer
